<template lang="html">
  <div id="info-page-s2">

    <section class="info-section-1">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 text-center col-text">
            <h1 class="title-s1">CROMATOGRAFÍA</h1>

            <p>
              Cromatografía para Cannabinoides.<br />
              <br />
              Certificación Única en México<br />
              <br />
              Acredite su producto con los estándares legales
            </p>

            <p class="mt-4 text-center">
              <router-link class="btn btn-s2 outline-white" target="_blank" to="/producto/41">CONTRATAR</router-link>
            </p>
          </div>

          <div class="col-lg-6 col-paper">
            <img src="public/images/pages/info-pages/cromatografia.jpg">
          </div>
        </div>
      </div>
    </section>

    <section class="info-section-2">
      <div class="container">
        <div class="row">
          <div class="col-lg-5 col-title">
            <h2 class="title-s1 v2">Características Principales</h2>
          </div>

          <div class="col-lg-6 offset-lg-1 col-text">
            <p>
              Certificación de Cannabinoides: Evaluamos y certificamos los niveles de cannabinoides en destilados, plantas y productos terminados.
            </p>

            <h5 class="mt-4 subtitle">CUMPLIMIENTO LEGAL</h5>
            <p>
              Acredite que su producto cumple con la ley federal y los porcentajes de THC.
            </p>

            <h5 class="mt-4 subtitle">SOPORTE LEGAL</h5>
            <p>
              Contamos con un área legal para llevar sus procesos de amparo para la distribución legal y libre.
            </p>

            <p class="mt-4 text-center">
              <router-link class="btn btn-s2 outline-green" to="/eum_legal">EUM LEGAL</router-link>
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="info-section-3">
      <div class="container">
        <div class="row">
          <div class="col-12 col-xl-10 mx-auto col-title">
            <h2 class="mb-1 title-s1">Nuestro Proceso de Certificación</h2>
            <p>
              EXTRACTOS EUM ofrece un servicio único en México para evaluar y certificar los niveles de cannabinoides. Asegure que su producto cumple con las regulaciones legales.
            </p>
          </div>

          <div class="col-lg-6 col-info" v-for="(c, chInx) in certifications" :key="'chInx-'+chInx">
            <h6 class="title">{{ c.title }}</h6>
            <p class="text">
              {{ c.text }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="info-section-4">
      <div class="container">
        <div class="row">
          <div class="col-12 col-info-1 p-sm">
            <h2 class="text-center title-s1">Cromatografía</h2>

            <h4 class="f-w-700">La Evolución de la Cromatografía Líquida U-HPLC</h4>
            <p>
              La cromatografía líquida ha sido una técnica analítica esencial en la industria, y su evolución ha sido constante y emocionante. Aquí hay un vistazo rápido a su trayectoria:
            </p>

            <br />
            <p>
              <strong>1. Década de los 70:</strong> Se introduce el término HPLC (Cromatografía Líquida de Alto Rendimiento). La gran diferencia era la presión del disolvente (400bar), lo que llevó a un mayor rendimiento en rapidez, selectividad, sensibilidad y usabilidad.
            </p>

            <br />
            <p>
              <strong>2. Avances Tecnológicos:</strong> El sistema de detección avanzó de la observación visual a técnicas espectroscópicas como UV-VIS, IR, FLD y los primeros MS. También apareció la FLASH LC, que presurizaba el solvente y se acoplaba a nuevos detectores.
            </p>

            <br />
            <p>
              <strong>3. Desarrollos Continuos:</strong> Desde su inserción en los años 1970, la HPLC ha evolucionado para lograr mayor eficiencia, con partículas más pequeñas, columnas de mejor calidad, nuevos instrumentos robustos y resistentes, y la introducción de sistemas de bajo flujo como NanoLC y CapliaryLC.
            </p>

            <br />
            <p>
              <strong>4. UHPLC – Cromatografía de Ultra Alto Rendimiento:</strong> La UHPLC es un paso más en la búsqueda de mayor rendimiento. No es un equipo determinado ni necesariamente de Ultra Alta presión, sino una técnica basada en relleno de alta eficiencia con partículas sub-2-micron.
            </p>

            <br />
            <p>
              <strong>4. UHPLC – Cromatografía de Ultra Alto Rendimiento:</strong> La UHPLC es un paso más en la búsqueda de mayor rendimiento. No es un equipo determinado ni necesariamente de Ultra Alta presión, sino una técnica basada en relleno de alta eficiencia con partículas sub-2-micron.
            </p>

            <h4 class="mt-4 f-w-700">Beneficios de la UHPLC</h4>
            <ul>
              <li><strong>Mayor Resolución Cromatográfica:</strong> Las nuevas partículas permiten una mayor resolución sin incrementar el tiempo de análisis.</li>
              <li><strong>Menor Consumo de Disolventes:</strong> Se logra una mayor sensibilidad sin perder resolución y con menor consumo de disolventes.</li>
              <li><strong>Alta Velocidad y Mayor Separación Cromatográfica:</strong> La UHPLC permite una alta velocidad y/o mayor separación cromatográfica, lo que la convierte en una técnica valiosa en la industria.</li>
            </ul>
          </div>

          <div class="col-lg-12 mb-3 col-info-2">
            <div class="box-numbers">
              <div class="box-number">
                <h3 class="number">432</h3>
                <h5 class="text">Cromatografías</h5>
              </div>

              <div class="box-number">
                <h3 class="number">264</h3>
                <h5 class="text">Clientes activos</h5>
              </div>
            </div>

            <div class="box-text">
              <p>
                En EXTRACTOS EUM, valoramos la innovación y la excelencia en todas nuestras operaciones. La UHPLC es un ejemplo perfecto de cómo la tecnología puede avanzar para ofrecer resultados más precisos y eficientes. Si desea saber más sobre cómo utilizamos estas técnicas en nuestros productos de CBD de alta calidad, no dude en ponerse en contacto con nosotros.
              </p>

              <br />
              <p>
                ¡Gracias por elegir EXTRACTOS EUM, su proveedor confiable de fitocannabinoides derivados del cáñamo industrial de la más alta calidad!
              </p>

              <p class="mt-4 text-center">
                <router-link class="btn btn-s2 outline-white" target="_blank" to="/producto/41">COMPRAR</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="info-section-5">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 mx-auto col-testimonials">
            <div class="box-testimonials">
              <swiper class="swiper" :options="testimonialsOption">
                <swiper-slide v-for="(t, thInx) in testimonials" :key="'thInx-'+thInx">
                  <div class="box-testimonial">
                    <div class="comment">
                      <h5>{{ t.comment }}</h5>
                    </div>

                    <h6 class="name">{{ t.name }}</h6>
                  </div>
                </swiper-slide>

                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="info-section-6">
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="col-md-9 col-lg-6 col-xl-5 col-image">
            <div class="image" v-bind:style="{ backgroundImage: 'url(public/images/pages/info-pages/eum.jpg)' }">
              <img src="public/images/shared/empty.png">
            </div>
          </div>

          <div class="col-lg-6 offset-xl-1 col-info">
            <h2 class="mb-1 title-s1">Sobre Nosotros</h2>

            <p class="mb-3">
              En EXTRACTOS UNIDOS MEXICANOS (EXTRACTOS EUM) Somos expertos en formulaciones de cannabinoides personalizadas.
            </p>
            <p class="mb-3">
              Un equipo de formuladores, químicos y gerentes de cuentas que están altamente capacitados para saber qué formulaciones y potencias de cannabinoides se combinan mejor con qué sistema de administración.<br />
              Pioneros en la industria y han construido la cadena de suministro de cannabinoides derivados del cáñamo más grande de EE. UU. ahora en México
            </p>
            <p class="f-w-600">
              Tenemos la mayor selección de aislados, destilados, sabores, fórmulas y sistemas de entrega.
            </p>

            <div class="box-networks">
              <a class="t-150 btn-network" target="_blank" href="https://www.facebook.com/extractoseum">
                <i class="fab fa-facebook-f"></i>
              </a>
              <a class="t-150 btn-network" target="_blank" href="https://twitter.com/Extractoseum">
                <i class="fab fa-twitter"></i>
              </a>
              <a class="t-150 btn-network" target="_blank" href="https://www.youtube.com/@extractoseum2886">
                <i class="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container info-section-7">
      <div class="row justify-content-center">
        <div class="col-12 col-info">
          <h1 class="mb-1 title-s1">Contacto</h1>

          <p class="p-lg">
            ¿Listo para Tomar el Control de tu Futuro en la Industria del Cannabis?.
          </p>
          <p>
            Nuestro equipo de expertos en EUM Legal está preparado para ayudarte a navegar por las complejas regulaciones y desarrollar estrategias personalizadas que se ajusten a tus necesidades. No dejes que las dudas legales te detengan. ¡Hagamos crecer tu negocio juntos!
          </p>
        </div>

        <div class="col-xl-9 col-form">
          <b-form @submit="onSubmit">
            <b-form-group class="form-group-s1"
              label="Nombre:">
              <b-form-input
                v-model="form.name"
                type="text"
                placeholder=""
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="form-group-s1"
              label="Correo electrónico:">
              <b-form-input
                v-model="form.email"
                type="email"
                placeholder=""
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="form-group-s1"
              label="Mensaje:">
              <b-form-textarea
                v-model="form.msg"
                placeholder=""
                rows="4"
                max-rows="4"
                required
              ></b-form-textarea>
            </b-form-group>

            <p class="text-center">
              <b-button type="submit" class="btn-s1 bg-cprimary">Enviar</b-button>
            </p>
          </b-form>
        </div>
      </div>
    </section>

    <section class="container info-section-10">
      <div class="row">
        <div class="col-lg-6 col-text">
          <h2 class="mb-2 title-s1">¡Asegure la Calidad de Sus Productos Hoy!</h2>
          <p class="p-lg">
            ¿Busca una certificación precisa y confiable para sus productos de cannabis? La Cromatografía Liquida U-HPLC de EXTRACTOS EUM es la solución que necesita. Con nuestra tecnología de ultra alto rendimiento, garantizamos una mayor resolución, sensibilidad y eficiencia en el análisis de cannabinoides.
          </p>

          <p class="mt-4 p-lg">
            Precio Especial por Volumen: Compre 3 piezas o más y obtenga un descuento exclusivo. Pague solo $1,800 por pieza.
          </p>

          <p class="mt-4 text-center">
            <router-link class="btn btn-s2 outline-green" target="_blank" to="/producto/41">COMPRAR</router-link>
          </p>
        </div>

        <div class="col-lg-5 pl-lg-5 col-image">
          <img src="public/images/pages/info-pages/cromatografia-2.jpg" alt="">
        </div>
      </div>
    </section>

    <section class="info-section-9">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-titles">
            <h2 class="title-s1">+20% EN PUNTOS</h2>
          </div>

          <div class="col-lg-7 offset-lg-1 col-info">
            <p class="p-lg">
              Unete a nuestro programa de afiliados, comparte y obtén hasta un 20% de tus compras en puntos redimibles y hasta un 20% de retribución en todas las compras que generen tus afiliados**
            </p>

            <p class="mt-4 p-sm">
              *(Aplicable en producto terminado -Gomitas, Goteros, Vapes y CandyKush Materias primas: CBD Aislado, Destilado CBD amplio espectro, Destilado CBD Espectro completo) promoción por tiempo indefinido.
            </p>
            <p class="mt-2 p-sm">
              *Sujeto a cambios sin previo aviso.
            </p>

            <p class="mt-4 text-center">
              <router-link class="btn btn-s2 outline-white" to="/login">UNIRME</router-link>
            </p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      certifications: [
        { title: 'Evaluación de Cannabinoides', text: 'Analizamos destilados, plantas y productos terminados como gomitas, vapes, comestibles y más.' },
        { title: 'Certificación Legal', text: 'Ofrecemos un certificado de análisis para acreditar que su producto cumple con la ley federal.' },
        { title: 'Soporte Legal', text: 'Contamos con un área legal para apoyar en los procesos de amparo para la distribución legal.' },
        { title: 'Calidad y Confiabilidad', text: 'Somos el proveedor líder en México, comprometidos con la calidad y la satisfacción del cliente.' },
        { title: 'Litigio estratégico', text: 'Litigio estratégico ante Tribunales Administrativos y jueces de Distrito (amparo).' },
      ],

      testimonials: [
        { name: 'Roberto Hernández, CEO de GreenLeaf Labs', comment: 'EXTRACTOS EUM transformó nuestra forma de certificar productos. Su análisis preciso y soporte legal nos brindaron la confianza que necesitábamos para expandir nuestro negocio en México. ¡Un servicio imprescindible para cualquier productor de cannabis!' },
        { name: 'Laura Jiménez, Farmacéutica en MedCanna', comment: 'La certificación de cannabinoides con EXTRACTOS EUM fue un proceso sin complicaciones. Su equipo experto nos guió en cada paso, asegurando que nuestros productos cumplieran con todas las regulaciones legales. ¡La tranquilidad que ofrecen es inigualable!' },
        { name: 'Carlos Vega, Propietario de Vega’s Edibles', comment: 'Como fabricante de comestibles de cannabis, necesitaba un servicio que no solo certificara mis productos sino que también me ofreciera soporte legal. EXTRACTOS EUM cumplió con creces, permitiéndome enfocarme en lo que mejor sé hacer. ¡Altamente recomendado!' },
        { name: 'Sofía Martínez, Directora de CannabiTech Labs', comment: 'La innovación y la calidad son fundamentales en nuestro laboratorio. EXTRACTOS EUM se alinea perfectamente con nuestros valores, ofreciendo una certificación precisa y confiable. Su experiencia en el marco jurídico del cannabis es un recurso invaluable para nuestra empresa.' },
        { name: 'Javier López, Agricultor de Cannabis Orgánico', comment: 'Como pequeño productor, estaba preocupado por los desafíos legales de la industria del cannabis. EXTRACTOS EUM me ofreció una solución completa, desde la certificación hasta el soporte legal. Ahora puedo cultivar y vender mis productos con total confianza.' },
        { name: 'María González, Fundadora de HerbalLife Wellness', comment: 'Nuestros clientes confían en la calidad y legalidad de nuestros productos de CBD. EXTRACTOS EUM ha sido un aliado clave en nuestra misión, ofreciendo una certificación rápida y un soporte legal excepcional. Su compromiso con la excelencia refleja el nuestro.' },
      ],

      form: {
        name: null,
        email: null,
        msg: null,
      },

      // == Carousel options ==
      testimonialsOption: {
        loop: true,
        speed: 700,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },

        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
      },
      // == ==
    }
  },

  methods: {
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-bottom-right',
        appendToast: true
      })
    },

    onSubmit(event) {
      event.preventDefault();

      var params = this.form;
      var apiURL = tools.url("/api/contact");

      axios.post( apiURL,params )
      .then( (response) => {
        // alert(response.data.response);
        this.makeToast('success', response.data.response, 'Mensaje enviado');
        // alert(response.data.response);

        for (let prop in this.form) {
          this.form[prop] = '';
        }
      })
      .catch( (error) => {
        // console.log(error.response.data);
        let errors = error.response.data;

        for (let prop in errors) {
          // console.log(errors[prop]);
          this.makeToast('danger', errors[prop], '¡Error!');
        }
      });
    },
  }
}
</script>
